import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette: { grey, type } }) => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflowY: "scroll",
    overflowX: "hidden",
    "@media (hover: hover)  and (pointer: fine)": {
      scrollbarColor: "#aaa transparent",
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        width: 8,
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "transparent",
      },
      "&:hover::-webkit-scrollbar-thumb": {
        background: type === "dark" ? grey[800] : grey[400],
      },
    },
  },
}));

export default useStyles;
